/**
 * klubb-club-subnav — applies the per-section sticky_top_offset to the CSS.
 * Section CSS uses a default; this overrides per instance.
 */
(function () {
  document.querySelectorAll('[data-klubb-club-subnav]').forEach((nav) => {
    // Section settings aren't directly accessible client-side; the section
    // can output an inline CSS variable if non-default offsets are needed.
    // For V1 we trust the default.
  });
})();

// Filter checkbox toggles — navigate to add/remove URL on change
document.addEventListener('change', (e) => {
  const cb = e.target.closest('[data-klubb-filter-toggle]');
  if (!cb) return;
  const url = cb.checked ? cb.dataset.urlAdd : cb.dataset.urlRemove;
  if (url) window.location.href = url;
});
